<template>
    <div class="fill-height">
        <TabBasic show-breadcrumbs>
            <v-container class="pa-0" fluid>
                <v-row>
                    <v-col class="page-content" cols="12">
                        <div class="mr-12">
                            <div class="d-flex align-center">
                                <v-text-field
                                        v-model="search"
                                        class="datatable-search"
                                        dense
                                        hide-details
                                        outlined
                                        prepend-inner-icon="mdi-magnify"/>
                            </div>
                            <v-data-table
                                    :headers="header"
                                    :items="filteredUsers"
                                    :loading="loading"
                                    :search="search"
                                    class="rounded-lg shadow my-6"
                                    sort-by="Role">
                                <template v-slot:[`header.Status`]>
                                    <FilterDropDown
                                            v-model="filters.status"
                                            :available-values="Array.from(availableValues.status)"
                                            :filter-values="userStatuses"
                                            :name="$t('status')"/>
                                </template>
                                <template v-slot:[`header.Role`]>
                                    <FilterDropDown
                                            v-model="filters.role"
                                            :available-values="Array.from(availableValues.role)"
                                            :filter-values="userRoles"
                                            :name="$t('circles.role')"/>
                                </template>
                                <template v-slot:[`item.AvatarUrl`]="{item}">
                                    <v-avatar size="35">
                                        <img
                                                v-if="item.AvatarUrl"
                                                :src="item.AvatarUrl"
                                                alt="avatar">
                                        <v-icon v-else size="50">
                                            mdi-account-circle
                                        </v-icon>
                                    </v-avatar>
                                </template>
                                <template v-slot:[`item.actions`]="{ item }">
                                    <TableAction v-if="isAdmin && item.UserID !== userID && item.Status===USER_ACTIVE"
                                                 :tooltip="$t('tooltips.sendNotification')"
                                                 icon="mdi-bell-badge"
                                                 @click="sendNotificationToUser(item)"/>
                                    <TableAction v-if="item.Status === USER_INVITED"
                                                 :tooltip="$t('tooltips.resendInvitation')"
                                                 icon="mdi-email-sync"
                                                 @click="resendInvitation(item.UserID)"/>
                                    <TableAction v-if="item.Status===USER_ACTIVE"
                                                 :tooltip="$t('tooltips.locationHistory')"
                                                 icon="mdi-map-marker-multiple"
                                                 @click="locationHistory(item.UserID)"/>
                                    <TableAction
                                            v-if="isAdmin &&  item.UserID !== organizationOwnerID && item.UserID !== userID "
                                            :icon="item.Role === ORGANIZATION_USER_ROLE_ADMIN ?'mdi-account  ':'mdi-account'"
                                            :icon-color="item.Role ===ORGANIZATION_USER_ROLE_ADMIN ? 'accent':null"
                                            :tooltip="item.Role === ORGANIZATION_USER_ROLE_ADMIN ? $t('tooltips.removeAdmin') : $t('tooltips.makeAdmin')"
                                            @click="changeUserRole(item)"/>
                                    <TableAction
                                            v-if="isAdmin &&  item.UserID !== organizationOwnerID && item.UserID !== userID"
                                            :tooltip="$t('tooltips.deleteUser')"
                                            icon="mdi-delete"
                                            @click="deleteUser(item.UserID)"/>
                                </template>
                                <template v-slot:[`item.JoinDate`]="{ item }">
                                    {{ formatDateTime(item.JoinDate) }}
                                </template>
                                <template v-slot:[`item.LastSeenAt`]="{ item }">
                                    {{ formatDateTime(item.LastSeenAt) }}
                                </template>
                                <template v-slot:[`item.LastLoginAt`]="{ item }">
                                    {{ formatDateTime(item.LastLoginAt) }}
                                </template>
                                <template v-slot:[`item.Circles`]="{ item }">
                                    <div
                                            v-if="item.Circles.length"
                                            class="pointer d-flex justify-space-between"
                                            @click="item.moreDetails = !item.moreDetails">
                                        <template v-if="!item.moreDetails">
                                            <div>
                                                {{
                                                item.Circles.map((app) => app.Name).join(', ')
                                                }}
                                            </div>
                                            <v-icon>
                                                mdi-chevron-down
                                            </v-icon>
                                        </template>
                                        <template v-else>
                                            <table>
                                                <tr v-for="(circle, index) in item.Circles" :key="index">
                                                    <td class="">{{ circle.Name }}:</td>
                                                    <td class="pl-5"> {{ circle.Role }}</td>
                                                </tr>
                                            </table>
                                            <v-icon>
                                                mdi-chevron-up
                                            </v-icon>
                                        </template>
                                    </div>
                                </template>
                                <template v-slot:[`item.Status`]="{item}">
                                    {{ getUserStatus(item.Status) }}
                                </template>
                            </v-data-table>
                        </div>
                        <div class="action-buttons">
                            <v-btn
                                    class="mb-4 accentText--text"
                                    color="accent"
                                    dark
                                    fab
                                    small
                                    @click="actionOpen = !actionOpen"
                            >
                                <v-icon v-if="actionOpen">
                                    mdi-chevron-down
                                </v-icon>
                                <v-icon v-else>
                                    mdi-chevron-up
                                </v-icon>
                            </v-btn>
                            <v-slide-y-transition>
                                <div v-show="actionOpen">
                                    <div class="mb-2 mt-2">
                                        <v-tooltip color="primary" left>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn
                                                        color="primary"
                                                        dark
                                                        fab
                                                        small
                                                        v-bind="attrs"
                                                        @click="openInviteDialog = true"
                                                        v-on="on">
                                                    <v-icon color="secondary">mdi-account-plus</v-icon>
                                                </v-btn>
                                            </template>
                                            <span class="secondary--text">{{ $t('tooltips.addNewMember') }}</span>
                                        </v-tooltip>
                                    </div>
                                    <div v-if="isAdmin" class="mb-2">
                                        <v-tooltip color="primary" left>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn
                                                        color="primary"
                                                        dark
                                                        fab
                                                        small
                                                        v-bind="attrs"
                                                        v-on="on">
                                                    <v-icon color="secondary" @click="openColumnSettings">
                                                        mdi-wrench-cog
                                                    </v-icon>
                                                </v-btn>
                                            </template>
                                            <span class="secondary--text">{{ $t('user.columnSettings') }}</span>
                                        </v-tooltip>
                                    </div>
                                </div>
                            </v-slide-y-transition>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </TabBasic>
        <DeleteDialog ref="deleteDialog" :loading="loadingDelete" :title="$t('user.areYouSureDeleteUser')"/>
        <ConfirmDialog ref="confirmDialog" :accept-title="$t('user.change')"
                       :popup-title="$t('user.confirmRoleChange')" :title="$t('user.areYouSureChangeRole')"/>
        <InviteDialog :open="openInviteDialog" @close="openInviteDialog=false" @invited="getUsers"/>
        <ColumnSelector v-model="allHeader" :open="openColumnSelector" @close="openColumnSelector = false"/>
    </div>
</template>

<script>
import TabBasic from "@/components/reusable/TabBasic/TabBasic";
import {ORGANIZATION_USER_ROLE_ADMIN, ORGANIZATION_USER_ROLE_USER, USER_ACTIVE, USER_INVITED} from "@/helper/constants";
import FilterDropDown from "@/components/reusable/FilterDropDown/FilterDropDown";
import {formatDateTime} from "@/helper/helper";
import DeleteDialog from "@/components/reusable/Dialog/DeleteDialog";
import InviteDialog from "@/components/reusable/Dialog/InviteDialog";
import ColumnSelector from "@/components/reusable/ColumnSelector/ColumnSelector";
import ConfirmDialog from "@/components/reusable/Dialog/ConfirmDialog";

export default {
  name: "UsersList",
  components: {ConfirmDialog, ColumnSelector, InviteDialog, DeleteDialog, FilterDropDown, TabBasic},
  mounted() {
    this.getUsers();
  },
  data() {
    return {
      users: [],
      search: '',
      loading: false,
      USER_INVITED,
      ORGANIZATION_USER_ROLE_ADMIN,
      openInviteDialog: false,
      openColumnSelector: false,
      actionOpen: true,
      loadingDelete: false,
      USER_ACTIVE,
      filters: {
        status: [],
        role: [],
      },
      availableValues: {
        status: new Set(),
        role: new Set(),
      },
      allHeader: [
        {text: this.$t('circles.avatar'), value: 'AvatarUrl', visible: true},
        {text: this.$t('authentication.firstName'), value: 'FirstName', visible: true},
        {text: this.$t('authentication.lastName'), value: 'LastName', visible: true},
        {text: this.$t('authentication.email'), value: 'Email', visible: true},
        {text: this.$t('menu.circles'), value: 'Circles', visible: false},
        {text: this.$t('circles.role'), value: 'Role', visible: true},
        {text: this.$t('status'), value: 'Status', visible: true},
        {text: this.$t('user.joinDate'), value: 'JoinDate', visible: false},
        {text: this.$t('user.lastSeenAt'), value: 'LastSeenAt', visible: true},
        {text: this.$t('user.lastLoginAt'), value: 'LastLoginAt', visible: true},
        {text: '', value: 'actions', align: 'center', visible: true, sortable: false},
      ]
    };
  },
  computed: {
    organizationOwnerID() {
      return this.$store.getters.getOrganizationOwnerID;
    },
    userID() {
      return this.$store.getters.getUserId;
    },
    isAdmin() {
      return this.$store.getters.isOrganizationAdmin;
    },
    filteredUsers() {
      return this.users.filter(user => this.filters.status.includes(user.Status) && this.filters.role.includes(user.Role));
    },
    header() {
      return this.allHeader.filter(header => header.visible);
    },
    userStatuses() {
      return [
        {
          value: USER_ACTIVE,
          text: this.$t('user.active')
        },
        {
          value: USER_INVITED,
          text: this.$t('user.invited')
        }
      ];
    },
    userRoles() {
      return [
        {
          value: ORGANIZATION_USER_ROLE_ADMIN,
          text: this.$t('user.admin')
        },
        {
          value: ORGANIZATION_USER_ROLE_USER,
          text: this.$t('circles.user')
        }
      ];
    }
  },
  methods: {
    formatDateTime,
    sendNotificationToUser(user) {
      this.$router.push({name: 'sendNotifications', params: {userID: user.UserID}});
    },
    getUsers() {
      let url = this.$store.getters.getOrganizationUsers(this.$store.getters.getOrganizationId);
      this.loading = true;
      this.axios.get(url).then(({data}) => {
        this.users = data.Result.map(user => ({...user, moreDetails: false,}));
        this.users.forEach(user => {
          this.availableValues.status.add(user.Status);
          this.availableValues.role.add(user.Role);
        });
      }).finally(() => {
        this.loading = false;
      });
    },
    getUserStatus(status) {
      switch (status) {
        case USER_ACTIVE:
          return this.$t('user.active');
        case USER_INVITED:
          return this.$t('user.invited');
      }
      return status;
    },
    resendInvitation(userID) {
      const url = this.$store.getters.resendInvitation(userID);
      this.$store.dispatch('setLoader', true);
      this.axios.post(url).then(() => {
        this.$store.dispatch('addNotification', {
          type: 'success',
          message: this.$t('success.invitationWasResent'),
        });
      }).finally(() => {
        this.$store.dispatch('setLoader', false);
      });
    },
    changeUserRole(user) {
      this.$refs.confirmDialog.openDialog().then((res) => {
        if (res) {
          const url = this.$store.getters.organizationUserRole(user.UserID);
          let role = ORGANIZATION_USER_ROLE_USER;
          if (user.Role === ORGANIZATION_USER_ROLE_USER) {
            role = ORGANIZATION_USER_ROLE_ADMIN;
          }
          if (this.loading) {
            return;
          }
          this.loading = true;
          this.axios.put(url, role).then(() => {
            this.$store.dispatch('addNotification', {
              type: 'success',
              message: this.$t('success.userRoleWasUpdated'),
            });
            this.getUsers();
          }).finally(() => {
            this.loading = false;
          });
        }
      });

    },
    deleteUser(userID) {
      this.$refs.deleteDialog.openDialog().then(result => {
        if (result) {
          const url = this.$store.getters.getOrganizationUsers(this.$store.getters.getOrganizationId, userID);
          this.$store.dispatch('setLoader', true);
          this.loadingDelete = true;
          this.axios.delete(url).then(() => {
            this.getUsers();
          }).finally(() => {
            this.$store.dispatch('setLoader', false);
            this.loadingDelete = false;
          });
        }
      });
    },
    locationHistory(userID) {
      this.$router.push({name: 'locationHistory', params: {id: userID}});
    },
    openColumnSettings(event) {
      event.target.blur();
      this.openColumnSelector = true;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "users-list";
</style>